"use client";

import { useEffect } from "react";

export default function ViewTracker({ postId }) {
  useEffect(() => {
    // Track view after component mounts (when user actually views the page)
    const trackView = async () => {
      try {
        await fetch(`/api/blog/${postId}/views`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        });
      } catch (error) {
        // Silently fail - don't break the user experience
        console.warn("Failed to track view:", error);
      }
    };

    // Track view after a short delay to ensure the user is actually reading
    const timer = setTimeout(trackView, 2000);

    return () => clearTimeout(timer);
  }, [postId]);

  // This component doesn't render anything visible
  return null;
}